import { IHighRiskSupplementCategoryDTO } from '@interfaces/highRiskSupplements';

export class HighRiskSupplementsCategory {
  id: number | null;

  name: string;

  normalizedName: string;

  constructor(dto: IHighRiskSupplementCategoryDTO) {
    const data: IHighRiskSupplementCategoryDTO =
      dto && typeof dto === 'object' ? dto : ({} as IHighRiskSupplementCategoryDTO);
    this.id = typeof data.id === 'number' ? data.id : null;
    this.name = typeof data.name === 'string' ? data.name : '';
    this.normalizedName = this.name.toLowerCase().replaceAll(' ', '');
  }
}
